<div
  class="spacer"
  [style]="{ width: width + widthUnit, height: height + heightUnit }"
></div>
<div
  *ngIf="showDivider"
  class="divider"
  [style]="{ width: width + widthUnit }"
></div>
